<script lang="ts">
  let {
    message = '',
    type = 'info'
  }: {
    message: string;
    type?: 'success' | 'error' | 'info' | 'warning';
  } = $props();
</script>

{#if message}
  <div class="upload-message" class:success={type === 'success'} class:error={type === 'error'} class:info={type === 'info'} class:warning={type === 'warning'}>
    {message}
  </div>
{/if}

<style lang="scss">
  .upload-message {
    margin-top: var(--spacing-md);
    padding: var(--spacing-md) var(--spacing-lg);
    border-radius: var(--radius-lg);
    font-size: var(--font-size-sm);
    animation: slideDown var(--transition-fast);

    &.success {
      background: var(--color-success-light);
      color: var(--color-success);
      border: 1px solid var(--color-success-border);
    }

    &.error {
      background: var(--color-danger-light);
      color: var(--color-danger);
      border: 1px solid var(--color-danger-border);
    }

    &.info,
    &.warning {
      background: var(--color-warning-light);
      color: var(--color-warning-dark);
      border: 1px solid var(--color-warning-border);
    }
  }
</style>
